import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import ChangePassWordTab from './ChangePassWordTab';
import {getInfomationAccountFromToken, isValidUrl} from '../../utils/helper';
import SettingsTab from './SettingsTab';
import { BaseGatewayImage } from '../../utils/apiUrl';

import {
    getByIdAccountAction,
    getAccountAuthInfoByIdAccountAction,
    getAccountInfoByIdAccountAction
} from '../../store/reducers/account';
import { userManager } from '@app/utils/oidc';

const Profile = () => {
    const [activeTab, setActiveTab] = useState('SETTINGS');
    const [userName, setUserName] = useState('');
    const [t] = useTranslation();
    const dispatch = useDispatch();

    const itemAccount = useSelector((state) => state.account.itemAccount);
    const itemAccountAuthInfo = useSelector((state) => state.account.itemAccountAuthInfo);
    const itemAccountInfo = useSelector((state) => state.account.itemAccountInfo);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    useEffect(async () => {
        const accountItem = getInfomationAccountFromToken();
        const oidcProfile = await userManager.getUser().then(user => user ? user.profile : null);
        setUserName(oidcProfile?.preferred_username || 'Chưa cập nhật mã');
        if (accountItem) {
            dispatch(getByIdAccountAction(accountItem.id));
            dispatch(getAccountAuthInfoByIdAccountAction(accountItem.id));
            dispatch(getAccountInfoByIdAccountAction(accountItem.id));
        }
    }, [dispatch]);

    const fullName = [
        itemAccountAuthInfo?.lastName,
        itemAccountAuthInfo?.middleName,
        itemAccountAuthInfo?.firstName
    ].filter(Boolean).join(' ') || itemAccount?.fullName || 'Chưa cập nhật';

    const donViName = itemAccountInfo?.donVis?.map(d => d.tenDonVi).join(', ') || 'Chưa cập nhật';
    const email = itemAccountAuthInfo?.email || itemAccount?.email || 'Chưa cập nhật';
    const phoneNumber = itemAccountAuthInfo?.phoneNumber || 'Chưa cập nhật';
    const doiTuongName = itemAccountInfo?.doiTuong?.tenDoiTuong || 'Chưa cập nhật';
    const chucDanhChuyenMonName = itemAccountInfo?.chucDanhChuyenMon?.tenDoiTuong || 'Chưa cập nhật';
    const chuyenMonName = itemAccountInfo?.chuyenMons?.map(c => c.tenChuyenMon).join(', ') || 'Chưa cập nhật';
    const chucVuName = itemAccountInfo?.chucVus?.map(c => c.tenChucVu).join(', ') || 'Chưa cập nhật';
    
    const trinhDoArray = itemAccountInfo?.quaTrinhDaoTaos?.map(q => q.trinhDo?.tenTrinhDo).filter(Boolean) || [];
    const trinhDoName = Array.from(new Set(trinhDoArray)).join(', ') || 'Chưa cập nhật';

    const imageThumbnail = itemAccountAuthInfo?.imageThumbnail;
    const avatarUrl = imageThumbnail 
        ? (isValidUrl(imageThumbnail) ? imageThumbnail : `${BaseGatewayImage}/${imageThumbnail.replace(/^\//, '')}`) 
        : "/img/default-profile.png";

    console.log('itemAccountAuthInfo', itemAccountAuthInfo);
    console.log('itemAccountInfo', itemAccountInfo);

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Tài khoản</h1>
                        </div>
                        <div className="col-sm-6 d-flex justify-content-sm-end align-items-center mt-2 mt-sm-0">
                            <Link
                                to="/"
                                title="Về trang chủ"
                                className="btn btn-sm btn-outline-primary shadow-sm d-inline-flex align-items-center"
                                style={{
                                    gap: '6px',
                                    borderRadius: '8px',
                                    fontWeight: 600,
                                    padding: '6px 12px'
                                }}
                            >
                                <i className="fas fa-home" aria-hidden="true" />
                                <span>{t('header.label.home')}</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="card card-primary card-outline">
                                <div className="card-body box-profile">
                                    <div className="text-center" style={{ marginBottom: '20px' }}>
                                        <img
                                            className="profile-user-img img-fluid img-circle"
                                            src={avatarUrl}
                                            alt="User profile"
                                            style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                        />
                                    </div>
                                    {/* <h3 className="profile-username text-center">
                                        {itemAccount
                                            ? itemAccount.username
                                            : ''}
                                    </h3> */}
                                    {/* <p className="text-muted text-center text-uppercase font-weight-bold">
                                        {fullName}
                                    </p> */}
                                    <ul className="list-group list-group-unbordered mb-3">
                                        <li className="list-group-item">
                                            <b>Tài khoản</b>
                                            <span className="float-right">{userName}</span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Họ tên</b>
                                            <span className="float-right">{fullName}</span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Email</b>
                                            <span className="float-right">{email}</span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Số điện thoại</b>
                                            <span className="float-right">{phoneNumber}</span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Đơn vị</b>
                                            <span className="float-right text-right" style={{ maxWidth: '60%' }}>{donViName}</span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Chức vụ</b>
                                            <span className="float-right text-right" style={{ maxWidth: '60%' }}>{chucVuName}</span>
                                        </li>
                                        {/* <li className="list-group-item">
                                            <b>Trình độ</b>
                                            <span className="float-right text-right" style={{ maxWidth: '60%' }}>{trinhDoName}</span>
                                        </li> */}
                                        <li className="list-group-item">
                                            <b>Chức danh chuyên môn</b>
                                            <span className="float-right text-right" style={{ maxWidth: '60%' }}>{chucDanhChuyenMonName}</span>
                                        </li>
                                        <li className="list-group-item">
                                            <b>Chức danh đang hoạt động</b>
                                            <span className="float-right text-right" style={{ maxWidth: '60%' }}>{doiTuongName}</span>
                                        </li>
                                        {/* <li className="list-group-item">
                                            <b>Chuyên môn</b>
                                            <span className="float-right text-right" style={{ maxWidth: '60%' }}>{chuyenMonName}</span>
                                        </li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="card">
                                <div className="card-header p-2">
                                    <ul className="nav nav-pills">
                                        <li className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-link ${
                                                    activeTab === 'SETTINGS'
                                                        ? 'active'
                                                        : ''
                                                }`}
                                                onClick={() =>
                                                    toggle('SETTINGS')
                                                }
                                            >
                                                Cập nhật tài khoản
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-link ${
                                                    activeTab ===
                                                    'CHANGEPASSWORD'
                                                        ? 'active'
                                                        : ''
                                                }`}
                                                onClick={() =>
                                                    toggle('CHANGEPASSWORD')
                                                }
                                            >
                                                Đổi mật khẩu
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                               
                                <div className="card-body">
                                    <div className="tab-content">
                                        <SettingsTab
                                            isActive={activeTab === 'SETTINGS'}
                                        />
                                        <ChangePassWordTab
                                            isActive={
                                                activeTab === 'CHANGEPASSWORD'
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Profile;
